<template>
  <div class="content-container">
    <el-table class="tablebox" :data="repaymentList" row-key="id" border ref="tableBox" :height="tableHeight"
              :row-class-name="tableRowClassName">
      <el-table-column label="期数" prop="num" width="80px"></el-table-column>
      <el-table-column label="还款本金" prop="principal"></el-table-column>
      <el-table-column label="还款利息" prop="interest"></el-table-column>
      <el-table-column label="月利率" prop="rates"></el-table-column>
      <el-table-column label="GPS费" prop="gpsFee"></el-table-column>
      <el-table-column label="服务费" prop="serveFee"></el-table-column>
      <el-table-column label="还款日期" prop="date"></el-table-column>
      <el-table-column label="是否还款" prop="status">
        <template slot-scope="scope">
          <p>{{ $dict.nameOf('yes_no', scope.row.status) }}</p>
        </template>
      </el-table-column>
      <el-table-column label="是否逾期" prop="isOverdue">
        <template slot-scope="scope">
          {{ $dict.nameOf('yes_no', scope.row.isOverdue) }}
        </template>
      </el-table-column>
      <el-table-column label="逾期罚息" prop="interestPenalty"></el-table-column>
      <el-table-column label="逾期天数" prop="interestDay"></el-table-column>
      <!--      <el-table-column v-if="hasPer('order:repay')" label="操作" width="80px">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-button v-if="scope.row.status === '0'" type="primary" size="small" @click="repay(scope.row)">还款</el-button>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
    </el-table>
  </div>
</template>

<script>
import {infoMsg, successMsg} from "@/utils/message";
import {hasPer} from "@/utils/common";
import {orderRepay, orderRepayList} from "@/api/order/order";

export default {
  name: "OrderRepayment",
  components: {},
  props: {
    repaymentList: {
      type: Array,
      require: true
    },
    height: {
      type: Number,
      require: true,
      default: 500
    }
  },
  data() {
    return {
      params: {}
    }
  },
  computed: {
    tableHeight() {
      return `${this.height}px`;
    }
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.$nextTick(() => {
        if (this.$refs.tableBox) {
          this.$refs.tableBox.doLayout();
        }
      });
    });
  },
  destroyed() {
    window.removeEventListener("resize", () => {
      this.$nextTick(() => {
        if (this.$refs.tableBox) {
          this.$refs.tableBox.doLayout();
        }
      });
    });
  },
  methods: {
    hasPer,
    tableRowClassName({row}) {
      if (row.isOverdue === '1') {
        return 'overdue-row';
      }
      return '';
    },
    repay(row) {
      // 确认后发送请求
      this.$confirm('确定该期还款完成？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        orderRepay(row.id).then(() => {
          successMsg('操作成功')
          orderRepayList(row.orderNo).then(res => {
            this.$emit('update:repaymentList', res)
            this.$forceUpdate()
          })
        })
      }).catch(() => {
        infoMsg('操作已取消')
      })
    }
  }
}
</script>

<style scoped>
.tablebox {
  height: auto;
  overflow-y: auto;
}

.overdue-row {
  background-color: #ffcccc; /* 标红颜色 */
}
</style>
